import { reduxKey } from '../../constants';
export const getLayout = (state)=>{
    var _state_reduxKey;
    return (_state_reduxKey = state[reduxKey]) === null || _state_reduxKey === void 0 ? void 0 : _state_reduxKey.layout;
};
export const getVersion = (state)=>{
    var _getLayout;
    return (_getLayout = getLayout(state)) === null || _getLayout === void 0 ? void 0 : _getLayout.version;
};
export const getZones = (state)=>{
    var _getLayout;
    return (_getLayout = getLayout(state)) === null || _getLayout === void 0 ? void 0 : _getLayout.zones;
};
export const getAllInstalledModuleIds = (state)=>{
    const zones = getZones(state);
    return Object.values(zones).map(({ installedModulesIds })=>installedModulesIds).flat(1);
};
